export default "https://c.travel-assets.com/partner-portal/server.fac20cd87f40.svg";